/**
 * Human-readable label for modals (delete/duplicate) when the first table column
 * may point at a nested relation object instead of a scalar.
 */
export function getRecordPreviewLabel(selectedRecord, tableColumns, entityName = 'Record') {
  if (!selectedRecord) return '';

  const col = Array.isArray(tableColumns) ? tableColumns[0] : null;
  const fallback =
    selectedRecord.code ||
    selectedRecord.title ||
    `${entityName} #${selectedRecord.id}`;

  if (!col?.key) {
    return fallback;
  }

  const raw = selectedRecord[col.key];
  if (raw != null && typeof raw === 'object' && !(raw instanceof Date)) {
    const o = raw;
    if (o.firstName != null || o.lastName != null) {
      const name = [o.firstName, o.lastName].filter(Boolean).join(' ').trim();
      if (name) return name;
    }
    if (o.title != null) return String(o.title);
    if (o.name != null) return String(o.name);
    if (o.userDisplayName != null) return String(o.userDisplayName);
    if (o.code != null && o.title != null) return `${o.code} — ${o.title}`;
    if (o.code != null) return String(o.code);
    return fallback;
  }

  if (raw != null && raw !== '') {
    if (raw instanceof Date) return raw.toLocaleString();
    return String(raw);
  }

  return fallback;
}
